import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../utils/cropImage";

export default function ImageCropper({ file, imageUrl, onCropped, disabled }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [accepted, setAccepted] = useState(false);

  const handleCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const generateCropped = useCallback(async () => {
    try {
      // Force crop update before generating
      if (!croppedAreaPixels) {
        console.warn("No crop area, forcing default crop.");
        return;
      }
      const blob = await getCroppedImg(file, croppedAreaPixels);
      const preview = URL.createObjectURL(blob);
      setPreviewUrl(preview);
      onCropped(blob, file.name); // only called when accepted
      setAccepted(true);
    } catch (err) {
      console.error(err);
    }
  }, [croppedAreaPixels, file, onCropped]);

  return (
    <div className="flex flex-col items-center gap-2 border p-2 rounded">
      <div className="relative w-full h-64 bg-gray-200" style={{ touchAction: "none" }}>
        <Cropper
          image={imageUrl}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
        />
      </div>
      <input
        type="range"
        min={1}
        max={3}
        step={0.05}
        value={zoom}
        onChange={(e) => setZoom(Number(e.target.value))}
        className="w-full"
        disabled={disabled}
      />
      {previewUrl && (
        <div className="mt-2 w-32 h-32 border">
          <img src={previewUrl} alt="Preview" className="w-full h-full object-cover" />
        </div>
      )}
      <button
        onClick={generateCropped}
        onTouchEnd={generateCropped} // for mobile devices
        disabled={accepted || disabled}
        className={`mt-2 px-4 py-1 rounded text-white ${
          accepted ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"
        }`}
      >
        {accepted ? "Crop Accepted" : "Accept Crop"}
      </button>
    </div>
  );
}
